import { SelectionModel } from '@angular/cdk/collections';

export class SelectionForm<T> {
  protected readonly selectionModel = new SelectionModel<T>(true);

  protected initialSelection: T[] = [];
  protected _dirty = false;

  constructor() {}

  get dirty(): boolean {
    return this._dirty;
  }

  hasChanged(i: T): boolean {
    return this.decideSelectionChangeType(i) !== 'None';
  }

  decideSelectionChangeType(item: T): SelectionChangeType {
    const wasSelected = this.initialSelection.includes(item);
    const isNowSelected = this.selectionModel.isSelected(item);

    if (wasSelected === isNowSelected) {
      return 'None';
    }

    return wasSelected ? 'Deselect' : 'Select';
  }

  isSelected = (item: T): boolean => {
    return this.selectionModel.isSelected(item);
  }

  init(...items: T[]) {
    this.clear();
    this.selectionModel.select(...items);
    this.initialSelection = items;
  }

  toggle(item: T) {
    this.selectionModel.toggle(item);
    this._dirty = true;
  }

  select(...items: T[]): void {
    this.selectionModel.select(...items);
    this._dirty = true;
  }

  deselect(...items: T[]): void {
    this.selectionModel.deselect(...items);
    this._dirty = true;
  }

  clear(): void {
    this.selectionModel.clear();
    this._dirty = false;
  }

  reset(): void {
    this.clear();
    this.select(...this.initialSelection);
  }
}

export type SelectionChangeType = 'Select' | 'Deselect' | 'None';
